module.exports = __webpack_public_path__ + "img/setting-4.97b953ed.svg";